function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "btwoevolution",
  d: "M25.5,8.224h-.822v3.29l-3.29-3.29V19.738a1.624,1.624,0,0,1-1.645,1.645H18.1v4.934l-4.934-4.934H6.587a1.624,1.624,0,0,1-1.645-1.645V14.8H1.652a1.589,1.589,0,0,1-1.169-.476,1.587,1.587,0,0,1-.475-1.169V3.29A1.589,1.589,0,0,1,.484,2.121a1.589,1.589,0,0,1,1.169-.476h9.869A1.624,1.624,0,0,1,13.167,3.29V4.935h3.29V.822A.789.789,0,0,1,16.7.244.794.794,0,0,1,17.28,0H25.5a.789.789,0,0,1,.578.244.794.794,0,0,1,.244.578V7.4a.835.835,0,0,1-.822.822ZM11.522,4.112a.835.835,0,0,0-.822-.822H2.475a.835.835,0,0,0-.822.822v8.224a.789.789,0,0,0,.244.578.794.794,0,0,0,.578.244H4.943V6.579a1.6,1.6,0,0,1,.476-1.156,1.569,1.569,0,0,1,1.169-.488h4.934V4.112ZM24.681,2.467a.835.835,0,0,0-.822-.822H18.924a.789.789,0,0,0-.578.244.794.794,0,0,0-.244.578V4.934h1.645A1.6,1.6,0,0,1,20.9,5.41a1.569,1.569,0,0,1,.488,1.169h2.467a.835.835,0,0,0,.822-.822V2.467Z",
  transform: "translate(-0.008)",
  fill: "#ac1ede"
});

var SvgBtwoevolution = function SvgBtwoevolution(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.318,
    height: 26.318,
    viewBox: "0 0 26.318 26.318",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtwoevolution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btwoevolution.74f59630.svg";
export { ForwardRef as ReactComponent };